export default __webpack_public_path__ + "static/media/Incidents_Image.2b8589d9.png";